import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Footer = styled.section`
  ${({ theme }) => css`
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 234px;
    background-color: ${theme.colors.primary.main};
    ${media.lessThan('medium')`
      height: 325px;
    `}
  `}
`

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
`

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: ${theme.colors.neutral.primary};

    ${media.lessThan('medium')`
      margin-top: 32px;
    `}
  `}
`

export const ImageWrapper = styled.div`
  position: absolute;
  width: 111px;
  height: auto;
  left: 64px;
  align-items: center;
  ${media.lessThan('medium')`
    left: auto;
    margin: 0 auto;
    top: 64px;
  `}
`

export const LogoVale = styled.img`
  width: 100%;
`

export const Subtitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.medium};
    line-height: ${theme.spacings.small};
    margin: 0 0 ${theme.spacings.xxsmall};
    font-weight: ${theme.font.black};
  `}
`

export const Text = styled.a`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.medium};
    line-height: ${theme.spacings.small};
    margin: 0 0 ${theme.spacings.xxsmall};
  `}
`

export const ButtonsGroup = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    justify-content: center;
    margin-bottom: ${theme.spacings.xsmall};
  `}

  ${media.lessThan('medium')`
    flex-wrap: wrap;
  `}
`

export const ButtonInfo = styled.a`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.medium};
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    margin: 0 ${theme.spacings.xxsmall};

    &:hover {
      opacity: 0.8;
    }
  `}
`
